export default {
  API_URL:'https://apilms.91trucks.com/api/v1',
  BASE_URL : 'https://apilms.91trucks.com',

  DATE_FORMAT: "MMM DD, YYYY",
  EXP_DATE_FORMAT: "MMM YYYY",
  HEADER_DATE_FORMAT: "DD MMM ddd, hh:mm a",
  INPUT_DATE_FORMAT: "DD-MM-YYYY",
  TICKET_DATE_FORMAT: "DD-MM-YYYY HH:MM:SS",
  TIME_FORMAT: "hh:mm a",
  GENDER: { m: "Male", f: "Female", M: "Male", F: "Female" },
  INCENTIVE_TYPE: {
    3: "Quarterly",
    4: "Half Yearly",
    1: "Monthly",
    2: "Annualy",
  },
  STATUS: { 0: "Inactive", 1: "Active" },
  BASE_URL_FRONTEND: window.location.origin,
  DP_INPUT_DATE_FORMAT: "dd-MM-yyyy",
  months: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ],
  transaction_categ_arr: { 0: "Deduction", 1: "Loan" },
  DB_DATE_FORMAT: "YYYY-MM-DD",
  UAE_DOCS: [1, 2, 3, 4, 5, 6],
  ONBOARDING_STATUS: {
    3: "To be Hired",
    4: "Offer Letter Accepted",
    5: "Visa Applied",
    6: "Onboarded",
    7: "Visa Applied",
    8: "Visa Approved",
    9: "Visa Rejected",
    10: "Offer Letter Rejected",
    11: "Offer Letter Sent",
    12: "Visa Status Changed",
    13: "Awaiting Visa Stamping",
    14: "Rejected",
    15: "Active",
  },
  advance_loan_role_id_allow: ["hr", "super-admin"],
  DEFAULT_USER_IMG_URL:
    "http://images.clipartpanda.com/user-clipart-matt-icons_preferences-desktop-personal.png",
  DEFAULT_ORG_IMG_URL:
    "https://splashpoolservices.com/wp-content/uploads/2016/05/client-dummy-new.png",
  VOW_FIRST_LOGO: "https://www.91trucks.com/_next/image?url=/91trucks-logo.png&w=256&q=75",
  DEFAULT_DOMAIN: "hrmsdev",
  blood_group: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
  secret_key: "hrms30062020",
  Google_Map_API: "AIzaSyAbbRTX7S0pXBp6OLQ-8x_-NtGUBKQePcs",
  vehicle_type_array: {
    5: "Tractor",
    6: "Truck",
    7: "Bus",
    8: "Three Wheelers",
   12: "Construction Equipments",  
  },
  Language: [
    "Hindi",
    "English",
    "Bengali",
    "Marathi",
    "Telugu",
    "Tamil",
    "Gujarati",
    "Urdu",
    "Kannada",
    "Odia",
    "Malayalam",
    "Punjabi",
    "Assamese",
    "Maithili",
    "Sanskrit",
    "Other",
  ],
  Vehicle_Type: [
    { v_type_id: "5", v_type_name: "Tractor" },
    { v_type_id: "6", v_type_name: "Truck" },
    { v_type_id: "7", v_type_name: "Bus" },
    { v_type_id: "8", v_type_name: "Three Wheelers" },
    { v_type_id: "10", v_type_name: "Other" },
    { v_type_id: "12", v_type_name: "Construction Equipments" },
    { v_type_id: "11", v_type_name: ["Tractor", ",", "Farm"] }
  ],
  mandatory_fields: [
    "email",
    "is_finance",
    "otp_verified",
    "pincode",
    "dealer_code",
    "dealer_id",
    "pancard",
    "dob",
    "name"
  ],
  null_mand_fields: ["pincode", "dealer_code", "dealer_id"],
  vendor_data_type: [
    "String",
    "Number",
    "BigInt",
    "Boolean",
    "UTC DateTime (with T & Z)",
  ],

  SUB_REASON: {
    94: [
      "Not Interested",
      "Did not like the Model",
      "Finance/ DP/ ROI issue",
      "Got bad reviews about respective Brand",
      "Need More Discount",
      "Not Happy with offers",
      "Price/ Out of Budget",
      "Stock unavailability/ Long waiting period",
      "Wants to buy SUV/ Hatchback/ Crossover",
      "Worried about After Sales/ Maintenance",
    ],
    95: ["More than 4 to 6 Months", "6 to 9 Months", "More than a Year"],
  },
  export_max_count: 10000,
};
